"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NavLinkContainer = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "NavLinkContainer",
  class: "pl-n13iqlzj",
  vars: {
    "n13iqlzj-0": [({
      partial
    }) => partial === 'dark1' ? _intents.default.ux.boxHighContrast.foregroundColor : _intents.default.ux.box.foregroundColor],
    "n13iqlzj-4": [({
      partial
    }) => partial === 'dark1' ? _intents.default.ux.boxHighContrast.foregroundColor : _intents.default.ux.box.foregroundColor]
  }
});

/**
 * DesktopNavLink - Desktop Clickable Link Component for Navigation
 *
 * A clickable anchor link component optimized for desktop navigation within the Enhanced Secondary Nav.
 * This component handles the interactive behavior of individual desktop navigation links including:
 * - URL navigation (href)
 * - Anchor scrolling functionality
 * - Active state styling
 * - Click tracking and analytics
 * - Desktop-specific responsive styling
 *
 * @param {Object} props React props
 * @param {number} [props.i] Link index for iteration contexts
 * @param {String} props._name Link tracking name for analytics
 * @param {String} props.href Link destination URL
 * @param {String} props.title Link display text
 * @param {Boolean} [props.active] Whether this link represents the current page/section
 * @param {String} [props.anchorId] Page section ID for anchor scrolling (overrides href)
 * @param {String} [props.partial] Theme partial identifier for dark theme styling
 * @param {Number} [props.tabIndex] Tab index for accessibility navigation
 * @param {Function} [props.scrollToAnchor] Handler for anchor link clicks
 * @param {String} [props.target] Link target attribute (e.g., '_blank')
 * @param {String} [props.rel] Link rel attribute (e.g., 'noopener noreferrer')
 * @returns {React.ReactElement} DesktopNavLink clickable anchor component
 * @public
 */

function DesktopNavLink({
  _name,
  href,
  title,
  active,
  anchorId,
  partial,
  tabIndex,
  scrollToAnchor,
  target,
  rel
}) {
  const ref = (0, _react.useRef)(null);
  _patternLibraryUtils.tracking.useTracking(ref);
  const trackingProps = _patternLibraryUtils.tracking.props(_name, true, false);
  return /*#__PURE__*/_react.default.createElement(NavLinkContainer, (0, _extends2.default)({
    className: "desktop-nav-link",
    ref: ref,
    "data-cy": "nav-link",
    href: anchorId ? '#' : href
  }, anchorId ? {
    'data-target': anchorId,
    'onClick': e => {
      scrollToAnchor(e);
    }
  } : {}, {
    target: target,
    rel: rel,
    "data-active": active,
    "data-partial": partial,
    tabIndex: tabIndex,
    partial: partial
  }, trackingProps), title);
}
var _default = exports.default = DesktopNavLink;
DesktopNavLink.propTypes = {
  _name: _propTypes.default.string,
  href: _propTypes.default.string,
  title: _propTypes.default.string,
  active: _propTypes.default.bool,
  anchorId: _propTypes.default.string,
  partial: _propTypes.default.string,
  tabIndex: _propTypes.default.number,
  scrollToAnchor: _propTypes.default.func,
  target: _propTypes.default.string,
  rel: _propTypes.default.string
};